import "./style.css";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import monitorApi from "../../api/monitorApi";
import { REACT_APP_FRONTEND_ROOT } from "../../config";
import { useSiteData } from "../../SiteDataContext";

function LoginPage() {
  const { t } = useTranslation();
  const { authState, setAuthState } = useSiteData();
  const location = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);

  const isFormValid = username.trim() !== "" && password.trim() !== "";

  useEffect(() => {
    if (authState.isAuthenticated && !authState.isLoading) {
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    }
  }, [
    authState.isAuthenticated,
    authState.isLoading,
    location.state,
    navigate,
  ]);

  const login_send = function (e: React.FormEvent) {
    e.preventDefault();

    if (!isFormValid) {
      return;
    }

    const payload = {
      username: username,
      password: password,
    };
    monitorApi
      .login(payload)
      .then((response) => {
        const token1 = response?.data?.token;
        if (token1) {
          setToken(token1);
          setErrorMessage(null);
        } else {
          setErrorMessage("Что-то пошло не так");
        }
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          setErrorMessage(error?.response?.data?.message);
        } else {
          setErrorMessage("Что-то пошло не так");
          console.info("There was an error fetching the data!", error);
        }
      });
  };

  useEffect(() => {
    if (token) {
      localStorage.setItem("auth_token", token);
      localStorage.setItem("auth_username", username);

      setAuthState({
        isAuthenticated: true,
        user: {
          username: username,
        },
        token: token,
        isLoading: false,
      });

      const from = location.state?.from?.pathname || "/";
      if (REACT_APP_FRONTEND_ROOT && from === "/") {
        window.location.href = REACT_APP_FRONTEND_ROOT;
      } else {
        navigate(from, { replace: true });
      }
    }
  }, [token, username, setAuthState, location.state, navigate]);

  return (
    <main className="min-h-screen flex items-center justify-center p-5">
      <form
        className="w-80 flex flex-col gap-4"
        onSubmit={login_send}
        data-testid="login-form"
      >
        <p className="text-4xl font-black text-center mb-1 md:tracking-wider">
          {t("login_page.login_title_text")}
        </p>
        <div className="w-full flex justify-between items-center">
          <p className="mr-3">{t("login_page.username_text")}</p>
          <input
            className="bg-slate-300 w-full max-w-[70%] rounded-md p-3 border-none outline-none focus:bg-slate-400 transition-colors"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="w-full flex justify-between items-center mb-1">
          <p className="mr-3">{t("login_page.password_text")}</p>
          <input
            className="bg-slate-300 w-full max-w-[70%] rounded-md p-3 border-none outline-none focus:bg-slate-400 transition-colors"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <input
          className={`rounded-md p-3 transition-colors duration-300 border-none text-base cursor-pointer ${
            isFormValid
              ? "bg-slate-300 text-black hover:bg-slate-400"
              : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }`}
          type="submit"
          value={t("login_page.button_text")}
          disabled={!isFormValid}
        />
        <div
          className={
            !errorMessage
              ? "hidden"
              : "rounded-md w-full bg-red-500 p-3 text-center text-white"
          }
        >
          {errorMessage}
        </div>
      </form>
    </main>
  );
}

export default LoginPage;
